import RestApiModel from "@/api/Model/RestApiModel";

class RiskCodeReference extends RestApiModel {
  static getResourceEndpoint() {
    return '/risk-code-references';
  }
}

export default RiskCodeReference;
